// app/src/features/signals/SignalLibraryOverlay.jsx
import React from "react";
import SignalLibraryDrawer from "../../components/SignalLibraryDrawer.jsx";

/**
 * The Signal Library drawer (its share of the frame's `overlays` slot, between the pipeline-debug
 * panel and the tour spotlight). Nothing without an active forecast. `SignalLibraryDrawer` keeps
 * its own `ctx` literal (components/*), built here from the frame's.
 *
 * Clicking a chip toggles selection (2-slot FIFO replace on the bar). Chip styling must match the
 * IndicesBar chips (components/IndicesBar.jsx) exactly, so the drawer and bar feel like one
 * surface. The drawer is full-width and never shifts when the side panels open. While open it is on
 * top of every rail panel (useDrawerStack), and beside an open one it reaches down to the window's
 * foot, where the bar it sits on does not run.
 */
export default function SignalLibraryOverlay({ ctx }) {
  const {
    active,
    theme,
    drawerZ,
    tsDrawerOpen,
    setTsDrawerOpen,
    chatOpen,
    railPanelOpen,
    manualQuery,
    setManualQuery,
    draggedChip,
    setDraggedChip,
    drawerOrder,
    setDrawerOrder,
    series,
    csvInputRef,
    verifySeries,
    addSeries,
    removeSeries,
    signalSuggestions,
    signalSuggestionsEnabled,
    signalSuggestionsLoading,
  } = ctx;
  return (
    <>
      {active && (
        <SignalLibraryDrawer
          ctx={{
            theme,
            zIndex: drawerZ.tsd,
            railInset: railPanelOpen ? "var(--rail-panel-w)" : 0,
            tsDrawerOpen,
            setTsDrawerOpen,
            chatOpen,
            manualQuery,
            setManualQuery,
            draggedChip,
            setDraggedChip,
            drawerOrder,
            setDrawerOrder,
            series,
            csvInputRef,
            verifySeries,
            addSeries,
            removeSeries,
            signalSuggestions,
            signalSuggestionsEnabled,
            signalSuggestionsLoading,
            signalHasQuestion: !!active?.question?.trim(),
          }}
        />
      )}
    </>
  );
}
